import { useParams } from 'react-router-dom';

import { useCurrentUser, useView } from '@/hooks';
import { ACTIVE_SURVEY_STATUSES } from '@/types';

import type { Survey } from '@/types';

import { useGetSurveysQuery } from '@/store/api/surveyApi';

export const useSurvey = () => {
  const { templateId = '' } = useParams();
  const { user, isUserLoading } = useCurrentUser();
  const { isCoach, isViewLoading, selectedUser } = useView();

  const contextUser = isCoach ? selectedUser : user;
  const userId = contextUser.id;

  const {
    data: surveys = [] as Survey[],
    isLoading: isSurveyLoading,
    refetch: refetchSurvey,
  } = useGetSurveysQuery(
    {
      templateId,
      userId,
    },
    {
      // For coach routes we need the selected user context; for member routes this is always available.
      skip:
        isUserLoading || (isCoach && isViewLoading) || !templateId || !userId,
    },
  );

  const survey = surveys[0] || ({} as Survey);
  const activeSurvey =
    surveys.find((candidate) =>
      ACTIVE_SURVEY_STATUSES.includes(candidate.status),
    ) || null;

  return {
    activeSurvey,
    isSurveyLoading,
    refetchSurvey,
    survey,
    surveys,
  };
};

export const useSurveys = () => {
  const { user, isUserLoading } = useCurrentUser();
  const { isCoach, isViewLoading, selectedUser } = useView();

  const contextUser = isCoach ? selectedUser : user;
  const userId = contextUser.id;

  const { data, isLoading, refetch } = useGetSurveysQuery(
    { userId },
    {
      // For coach routes we need the selected user context; for member routes this is always available.
      skip: isUserLoading || (isCoach && isViewLoading) || !userId,
    },
  );

  return {
    data,
    isLoading,
    refetch,
  };
};
